import { Avatar } from 'flowbite-react';
import React from 'react';
import { stringAvatar } from 'shared-utils';

const UsersAvatarGroup = ({ candidates }: { candidates: { name: string; profileImageUrl: string }[] }) => {
	return (
		<Avatar.Group className="justify-start -space-x-2">
			{candidates?.length > 5 ? (
				<Avatar.Group className="justify-start -space-x-2">
					{candidates
						?.slice(0, 5)
						.map((candidate, i) => (
							<Avatar
								key={i}
								className="w-[40px] h-[40px] [&_div]:!w-full [&_div]:!h-full [&_img]:w-full [&_img]:h-full [&_img]:!ring-[2px] [&_img]:!ring-[#7777E7] [&_img]:object-cover [&>div>div]:!ring-[2px] [&>div>div]:!ring-[#7777E7]"
								img={candidate?.profileImageUrl}
								placeholderInitials={stringAvatar(candidate?.name.trim().toUpperCase() || '')}
								rounded
								stacked
							/>
						))}
					<div className="font-inter font-[500] p-[10px] text-sm leading-[14px] w-[40px] h-[40px] rounded-full bg-[#CDF] ring-[#7777E7] ring-[1px] text-[#1F3343] z-[1] flex flex-wrap justify-center items-center text-center">
						<span className="text-xl leading-[20px] font-[600] ">+{candidates?.length - 5}</span>
					</div>
				</Avatar.Group>
			) : (
				<Avatar.Group className="justify-start -space-x-2">
					{candidates.map((candidate, i) => (
						<Avatar
							key={i}
							className="w-[40px] h-[40px] [&_div]:!w-full [&_div]:!h-full [&_img]:w-full [&_img]:h-full [&_img]:!ring-[2px] [&_img]:!ring-[#7777E7] [&_img]:object-cover [&>div>div]:!ring-[2px] [&>div>div]:!ring-[#7777E7]"
							img={candidate?.profileImageUrl}
							placeholderInitials={stringAvatar(candidate?.name.trim().toUpperCase() || '')}
							rounded
							stacked
						/>
					))}
				</Avatar.Group>
			)}
		</Avatar.Group>
	);
};

export default UsersAvatarGroup;
